<app-audio-recording #audioRecordingComponent
                     startRecordingIcon="microphone"
                     startRecordingTooltip="Commencer la retranscription"
                     stopRecordingTooltip="Arrêter la retranscription"
                     [startRecordingManually]="true"
                     [stopRecordingManually]="true"
                     (audioRecordStartRequestedEvent)="startTranscription()"
                     (audioRecordStopEvent)="stopTranscription()"
                     (audioChunkRecordedEvent)="audioChunkRecorded($event);">
</app-audio-recording>
